import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { LookupDataService } from '../services/lookup-data.service';

@Pipe({
  name: 'experienceType',
  pure: true,
})
export class ExperienceTypePipe implements PipeTransform {
  constructor(private lookupData: LookupDataService) {}

  transform(value: number | string | null | undefined): Observable<string> {
    if (value === null || value === undefined || value === '') {
      return of('نوع الخبرة غير محدد');
    }
    return this.lookupData.getExperienceTypes({
      selectedIds: [String(value)],
      pageNumber: 1,
      pageSize: 1
    }).pipe(
      map(result => {
        const name = result.items.find(t => String(t.id) === String(value))?.name;
        return name ?? 'نوع الخبرة غير محدد';
      })
    );
  }
}
